module.exports = __webpack_public_path__ + "media/images/flags/4x3/sjm-cc842bf6422415d73fd354e91a0c0e05.svg";